import React, { useState } from 'react';
import Select from 'react-select';
import PropType from 'prop-types';
import { colors, typography } from '../../styles/theme';

const colourStyles = (customStyles) => {
  return {
	container: (styles) => ({
		...styles,
		width: "100%",
		...customStyles
	}),
	control: (styles) => ({
		...styles,
		height: "3rem",
		border: `1px solid ${colors.neutral200}`,
		outline: 'none',
		boxShadow: 'none',
		borderRadius: '0.625rem',
		padding: '0.625rem 0.875rem',
		':hover': {
			...styles[':focus'],
			outline: 'none',
			boxShadow: 'none',
			borderColor: colors.neutral200,
			cursor: 'pointer',
		},
		':selected': {
			outline: 'none',
			boxShadow: 'none',
			borderColor: colors.neutral200,
		},
		':focus': {
			...styles[':focus'],
			outline: 'none',
			boxShadow: 'none',
			borderColor: colors.neutral200,
		},
		':active': {
			...styles[':active'],
			outline: 'none',
			boxShadow: 'none',
			borderColor: colors.neutral200,
		},
	}),
	menu: (styles) => ({
		...styles,
		border: `1px solid ${colors.neutral200}`,
		borderRadius: 0,
		boxShadow: 'none',
	}),
	menuList: (styles) => ({
		...styles,
		paddingTop: 0,
		paddingBottom: 0,
	}),
	option: (styles, { isDisabled, isFocused, isSelected, options, value }) => {
		const lastOption = options[options?.length-1]?.value === value;
		return {
			...styles,
			borderBottom: lastOption ? "none" : `1px solid ${colors.neutral200}`,
			padding: '1rem 0.75rem',
			...typography.textMd400,
			backgroundColor: isDisabled
				? undefined
				: isSelected
				? colors.primary100
				: isFocused
				? undefined
				: undefined,
			color: isDisabled
				? undefined
				: isSelected
				? colors.primaryMain
				: isFocused
				? undefined
				: undefined,
			cursor: isDisabled ? 'not-allowed' : 'pointer',
			':active': {
				...styles[':active'],
				backgroundColor: !isDisabled
					? isSelected
						? colors.primary100
						: colors.neutral200
					: undefined,
			},
			':hover': {
				...styles[':hover'],
				backgroundColor: !isDisabled
					? colors.primary100
					: colors.neutral200,
				color: !isDisabled ? colors.primaryMain : undefined
			},
		};
	},
	input: (styles) => ({
		...styles,
		...typography.textMd500,
		margin: 0,
		padding: 0,
	}),
	placeholder: (styles) => ({
		...styles,
		...typography.textMd500,
		margin: 0,
	}),
	indicatorSeparator: (styles) => ({
		...styles,
		display: 'none',
	}),
	indicatorsContainer: (styles) => ({
		...styles,
	}),
	valueContainer: (styles) => ({
		...styles,
		padding: 0,
	}),
	dropdownIndicator: (styles) => ({
		...styles,
		color: colors.primaryMain,
		padding: 0,
		width: '1.5rem',
		':hover': {
			color: colors.primaryMain,
		},
	}),
	singleValue: (styles) => ({ ...styles, ...typography.textMd500 }),
  }
};

const Dropdown = ({ options, placeholder, onChange, customStyles, ...props }) => {
	const [selectedOption, setSelectedOption] = useState();

	const handleSelect = (selectedOption) => {
		setSelectedOption(selectedOption);
		onChange(selectedOption);
	}

	return (
		<Select
			options={options}
			value={options.find(option => option?.value === selectedOption?.value )}
			placeholder={placeholder}
			onChange={handleSelect}
			menuShouldScrollIntoView
			styles={colourStyles(customStyles)}
			{...props}
		/>
	);
};

Dropdown.propTypes = {
	options: PropType.array,
	placeholder: PropType.string,
	onChange: PropType.func,
	customStyles: PropType.object,
};

export default Dropdown;
